import type { ReactNode } from "react";

/**
 * The picture blurred behind a live's door, the quick one and the scheduled one alike: the room's poster once it has
 * one, the host's photo until then, and the plain night only with neither. One place, so the two doors agree.
 */
export function DoorBackdrop({ poster, avatar }: { poster: string | null; avatar: string | null }): ReactNode {
  const src = poster || avatar;
  return src ? <img className="door-bg" src={src} alt="" aria-hidden="true" /> : null;
}
